import { h } from "preact";
import { observer } from "mobx-react";
import FieldError from "./FieldError";
function Switch(props) {
    const { controller, options, name, label, dataFieldId, extraClass, onChange, } = props;
    const hasError = (controller.isTouched && controller.isInvalid) ||
        (controller.isTouched && !controller.value);
    const handleChange = (option) => {
        const { value } = option;
        controller.change(value);
        if (onChange !== undefined) {
            onChange();
        }
    };
    return (h("fieldset", { class: `m-switch ${extraClass}`, "data-field-id": dataFieldId, style: `--switch-items-number:${options.length}` },
        h("legend", { class: "sr-only" }, label),
        options.map((option) => (h(SwitchOption, { name: name, isActive: controller.value === option.value, value: option.value, label: option.label, onChange: () => handleChange(option), onBlur: () => controller.blur(), key: option.value }))),
        hasError && h(FieldError, { errors: controller.errors })));
}
const SwitchOption = observer((props) => {
    const { name, value, label, isActive, onChange, onBlur } = props;
    const handleChange = () => {
        // Prevent from emitting event on already active item
        if (!isActive) {
            onChange();
        }
    };
    return (h("div", { key: value, class: `m-switch__item ${isActive ? "is-active" : ""}`, onClick: handleChange },
        h("input", { type: "radio", name: name, id: value, value: value, checked: isActive, onChange: handleChange, onBlur: onBlur, class: "m-switch__input" }),
        h("label", { class: "m-switch__label", for: value }, label)));
});
export default observer(Switch);
